import React from "react";

import { Box, SxProps, Theme } from "@mui/material";

import styles from "./Card.module.scss";

interface CACardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  size?: "small" | "medium" | "large";
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

export const CACard: React.FC<CACardProps> = ({
  children,
  className,
  hover = false,
  size = "medium",
  onClick,
  sx,
  ...props
}) => {
  const cardClasses = [styles.card, hover && styles.hover, size !== "medium" && styles[size], className]
    .filter(Boolean)
    .join(" ");

  return (
    <Box className={cardClasses} onClick={onClick} sx={sx} {...props}>
      {children}
    </Box>
  );
};
